import { createSelector, DuckSelector } from '@atc/modular-redux';

import { resultsDuckCreator } from 'axl-ducks';

import { srpDuckPreset } from '@/ducks/presets/index.js';

const srpResultsDuck = resultsDuckCreator({
    ...srpDuckPreset,
}).extend({
    selectors: (duck) => ({
        getInitialLoad: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).initialLoad),
        getStats: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).stats),
        getMaxActiveResultsCount: () => 300,
        getIsMaxActiveResults: new DuckSelector((selectors) => createSelector(
            selectors.getResultsCount,
            selectors.getActiveResultsCount,
            selectors.getMaxActiveResultsCount,
            (resultsCount, activeResultCount, getMaxActiveResultsCount) => resultsCount === activeResultCount || activeResultCount >= getMaxActiveResultsCount
        )),
    }),
});

export default srpResultsDuck;
